var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Watch } from 'vue-property-decorator';
import VueDialog from "../../../../../interface/IVueDialog";
import GoodService from '../../../../../api/GoodService';
import CategoryService from '../../../../../api/CategoryService';
import LeftTree from './LeftTree';
import TabTable from './TabTable.vue';
import LicenseBindGoodsTabTable from './tabTable/LicenseBindGoods';
import _ from 'lodash';
var EActiveType;
(function (EActiveType) {
    EActiveType["UN_SELECTED"] = "0";
    EActiveType["SELECTED"] = "1";
})(EActiveType || (EActiveType = {}));
var AddGoods = (function (_super) {
    __extends(AddGoods, _super);
    function AddGoods() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tabTableComponent = 'tab-table';
        _this.treeData = [];
        _this.tableData = [];
        _this.total = 0;
        _this.pagerCount = 5;
        _this.curGoodNode = {};
        _this.activeName = '0';
        _this.selectRows = [];
        _this.unSelectList = [];
        _this.selectedList = [];
        _this.canFreshTable = true;
        _this.formData = {};
        _this.searchKeyword = '';
        _this.isLoadingDetail = false;
        return _this;
    }
    AddGoods.prototype.visibleWatch = function (newVal) {
        if (this.formType === 'decoration') {
            this.getSelectedGoods();
            return;
        }
        else if (newVal) {
            this.getSelectedGoods();
            return;
        }
    };
    AddGoods.prototype.created = function () {
        this.getSelectedGoods();
    };
    AddGoods.prototype.getSelectedGoods = function () {
        this.service = GoodService.getInstance();
        this.categoryService = CategoryService.getInstance();
        this.getLeftTree();
        var goodsList = [];
        if (this.imageItem && this.imageItem.relate_id_good) {
            goodsList = this.imageItem && Array.isArray(this.imageItem.front_deliver_good) ? this.imageItem.front_deliver_good : [];
        }
        else {
            goodsList = this.imageItem && Array.isArray(this.imageItem.goods_list) ? this.imageItem.goods_list : [];
        }
        var addedDatas = Array.isArray(this.addedDatas) ? this.addedDatas : [];
        var allGoodsList = goodsList.concat(addedDatas);
        this.selectedList = _.cloneDeep(allGoodsList);
        this.activeName = EActiveType.UN_SELECTED;
        this.searchKeyword = '';
        this.gitRightList();
    };
    AddGoods.prototype.gitRightList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var params = {
            keyword: this.searchKeyword
        };
        if (this.curGoodNode && this.curGoodNode.goods_type_id != '-1') {
            params = Object.assign({}, params, {
                goods_type_id: this.curGoodNode.goods_type_id
            });
        }
        var goods_ids;
        goods_ids = (this.selectedList || []).map(function (item) {
            return item.goods_id;
        });
        this.isLoadingDetail = true;
        this.service.getGoodList(Object.assign({}, params, {
            status: -1,
            notin_goods_ids: goods_ids
        }, pager)).then(function (res) {
            _this.isLoadingDetail = false;
            if (res.data.success) {
                if (res.data.data.length == 0 && pager.page > 1) {
                    _this.search();
                    return;
                }
                _this.tableData = res.data.data;
                _this.unSelectList = res.data.data;
                _this.total = res.data.count;
                _this.setSelected(true);
            }
        }, function (err) {
            _this.isLoadingDetail = false;
            _this.$message.error(err.message);
        }).catch(function (err) {
            _this.isLoadingDetail = false;
            _this.$message.error(err.msg || err.message);
        });
    };
    AddGoods.prototype.selectChange = function (rows, currentRow, isSelectAll) {
        var _this = this;
        if (isSelectAll === void 0) { isSelectAll = false; }
        if (!this.canFreshTable)
            return;
        this.canFreshTable = false;
        var currentSelectRows = _.filter(rows, function (row) { return !!row; });
        this.selectedList = _.uniqBy(this.selectedList.concat(currentSelectRows), 'goods_id');
        var isUnselectAll = !currentSelectRows.length && !currentRow && isSelectAll;
        if (currentRow && !_.find(currentSelectRows, function (good) { return good.goods_id === currentRow.goods_id; })) {
            _.remove(this.selectedList, function (good) { return good.goods_id === currentRow.goods_id; });
        }
        else if (isUnselectAll && this.activeName === EActiveType.SELECTED) {
            this.selectedList = [];
        }
        else if (isUnselectAll) {
            this.unSelectList.forEach(function (good) {
                _.remove(_this.selectedList, function (item) { return item.goods_id === good.goods_id; });
            });
        }
        this.setSelected(this.activeName === EActiveType.SELECTED);
        this.$emit('previewDate', this.selectedList);
        setTimeout(function () {
            _this.canFreshTable = true;
            var pagination = _this.$refs.pagination;
            _this.gitRightList(pagination.getPage());
        });
    };
    AddGoods.prototype.handleClick = function (tab, event) {
        if (tab.name == "second") {
            this.setSelected();
        }
    };
    AddGoods.prototype.setSelected = function (isUnSelFresh) {
        var _this = this;
        if (isUnSelFresh === void 0) { isUnSelFresh = false; }
        var gridTable = this.$refs.grid.$refs.table;
        if (isUnSelFresh) {
            gridTable.clearSelection();
        }
        if (!this.selectedList.length) {
            this.$refs.alreadyGrid.$refs.table.clearSelection();
        }
        else {
            this.$emit('previewDate', this.selectedList);
            this.selectedList.forEach(function (good, index) {
                _this.$nextTick(function () {
                    _this.$refs.alreadyGrid.$refs.table.toggleRowSelection(good, true);
                });
                if (isUnSelFresh) {
                    var item_1 = _.find(_this.unSelectList, function (current) { return current.goods_id === good.goods_id; });
                    _this.$nextTick(function () {
                        gridTable.toggleRowSelection(item_1, true);
                    });
                }
            });
        }
    };
    AddGoods.prototype.getLeftTree = function () {
        var _this = this;
        this.categoryService.getCategoryTree().then(function (res) {
            _this.treeData = res.data.data;
        });
    };
    AddGoods.prototype.search = function () {
        var pagination = this.$refs.pagination;
        pagination.clear();
        this.gitRightList();
    };
    AddGoods.prototype.close = function () {
        this.$closeDialog();
        this.$emit('closeDiolog', false);
    };
    AddGoods.prototype.save = function () {
        var data = _.uniqBy(this.selectedList, 'goods_id');
        this.$emit('save:ok', data);
        this.$emit('closeData', data);
    };
    AddGoods.prototype.nodeClick = function (node) {
        this.curGoodNode = node || null;
        this.gitRightList();
    };
    AddGoods.prototype.pageChange = function (pager) {
        this.gitRightList(pager);
        this.$refs.grid.$refs.table.bodyWrapper.scrollTop = 0;
    };
    __decorate([
        Prop({
            type: Object
        })
    ], AddGoods.prototype, "imageItem", void 0);
    __decorate([
        Prop({
            type: Array
        })
    ], AddGoods.prototype, "addedDatas", void 0);
    __decorate([
        Prop({
            type: String
        })
    ], AddGoods.prototype, "formType", void 0);
    __decorate([
        Prop({
            type: Boolean
        })
    ], AddGoods.prototype, "dialogVisible", void 0);
    __decorate([
        Watch("dialogVisible", { immediate: true })
    ], AddGoods.prototype, "visibleWatch", null);
    AddGoods = __decorate([
        Component({
            components: {
                'left-tree': LeftTree,
                'tab-table': TabTable,
                'license-bind-goods-tab-table': LicenseBindGoodsTabTable
            }
        })
    ], AddGoods);
    return AddGoods;
}(VueDialog));
export default AddGoods;
